import React from 'react';

import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableFooter from '@mui/material/TableFooter';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import { MOCK_SCHEDULES } from '../../../../../../../services/driverJS/mocks';

import {
  BtnStyled,
  CellInputStyled,
  CellStepsStyled,
  DateInputStyled,
  FrequencyInputStyled,
  HeaderBoxStyled,
  InputBoxStyled,
  ItemNumStyled,
  LinearProgressStyled,
  NameStyled,
  PeriodsInputStyled,
  RootStyled,
  TableCellFixedStyled,
  TableCellHeaderFixedStyled,
  TableCellHeaderFixedTotalStyled,
  TableCellHeaderStickyStyled,
  TableCellHeaderStyled,
  TableCellStyled,
  TableContainerStyled,
  TableRowStyled,
} from './index.styles';

const percentageValues = [
  [0, 50, 50],
  [0, 10, 40],
  [30, 45, 30],
];

const totalPercentage = percentageValues.map((values) =>
  values.reduce((acc, curr) => acc + curr, 0)
);

export function TourSchedule() {
  function getTableRowClass(num) {
    const dots = num.split('').filter((character) => character === '.').length;
    if (dots === 0) return 'primary-item';
    if (dots === 1) return 'secondary-item';
    return 'tertiary-item';
  }

  function checkTotalPercentage(idxRow) {
    if (totalPercentage.length < 1) {
      return '';
    }
    if (
      totalPercentage[idxRow] !== undefined &&
      totalPercentage[idxRow] === 100
    ) {
      return (
        <span style={{ color: '#508239', fontWeight: 600 }}>
          {totalPercentage[idxRow]} %
        </span>
      );
    }
    if (
      totalPercentage[idxRow] !== undefined &&
      totalPercentage[idxRow] > 100
    ) {
      return (
        <span style={{ color: '#f51f0e', fontWeight: 600 }}>
          {totalPercentage[idxRow]} %
        </span>
      );
    }
    if (totalPercentage[idxRow] !== undefined && totalPercentage[idxRow] > 0) {
      return (
        <span style={{ color: '#eb7d36', fontWeight: 600 }}>
          {totalPercentage[idxRow]} %
        </span>
      );
    }
    return '';
  }

  return (
    <Paper>
      <RootStyled>
        <HeaderBoxStyled>
          <Box>
            <NameStyled variant="h1">Obra Tour</NameStyled>
            <Typography variant="body2">0 m²</Typography>
            <Typography variant="body2">
              Total orçado:{' '}
              <span style={{ color: '#64A348' }}>
                {new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(5000)}
              </span>
            </Typography>
            <Typography variant="body2">
              Total/m² orçado:{' '}
              <span style={{ color: '#64A348' }}>
                {new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(0)}
              </span>
            </Typography>
          </Box>
        </HeaderBoxStyled>
        <HeaderBoxStyled>
          <InputBoxStyled>
            <FrequencyInputStyled
              id="frequency-input"
              label="Periodicidade"
              variant="outlined"
              value="Mensal"
              select
              SelectProps={{
                MenuProps: {
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                  getContentAnchorEl: null,
                },
              }}
            >
              {['Semanal', 'Quinzenal', 'Mensal', 'Trimestral', 'Anual'].map(
                (option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                )
              )}
            </FrequencyInputStyled>
            <PeriodsInputStyled
              id="periods-input"
              label="Qtd de períodos"
              variant="outlined"
              type="number"
              value={3}
              slotProps={{ inputLabel: { shrink: true } }}
            />
            <DateInputStyled
              id="initial-date-input"
              type="date"
              label="Data inicial do cronograma"
              variant="outlined"
              value="2024-10-01"
              slotProps={{ inputLabel: { shrink: true } }}
            />
          </InputBoxStyled>
          <BtnStyled id="edit-schedule">Editar cronograma</BtnStyled>
        </HeaderBoxStyled>
        <TableContainerStyled id="schedules-table">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCellHeaderStickyStyled>
                  ETAPAS DO PROJETO
                </TableCellHeaderStickyStyled>
                <TableCellHeaderFixedStyled>%</TableCellHeaderFixedStyled>
                {['JAN / 2024', 'FEV / 2024', 'MAR / 2024'].map((data) => (
                  <TableCellHeaderStyled key={data}>
                    {data}
                  </TableCellHeaderStyled>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {MOCK_SCHEDULES.map((row, idxRow) => (
                <TableRowStyled
                  key={row.id}
                  className={getTableRowClass(row.item_num)}
                >
                  <CellStepsStyled>
                    <ItemNumStyled>{row.item_num}</ItemNumStyled>
                    {row.description}
                  </CellStepsStyled>
                  <TableCellFixedStyled>
                    {checkTotalPercentage(idxRow)}
                  </TableCellFixedStyled>

                  {[1, 2, 3].map((cell, i) => (
                    <TableCellStyled key={cell}>
                      <>
                        <CellInputStyled>
                          {percentageValues[idxRow][i]}
                        </CellInputStyled>
                        <LinearProgressStyled
                          variant="determinate"
                          value={percentageValues[idxRow][i]}
                        />
                      </>
                    </TableCellStyled>
                  ))}
                </TableRowStyled>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCellHeaderFixedStyled>
                  ORÇAMENTO DO PERÍODO
                </TableCellHeaderFixedStyled>
                <TableCellHeaderFixedTotalStyled>
                  {' '}
                </TableCellHeaderFixedTotalStyled>
                {[500, 1000, 2000].map((budget) => (
                  <TableCellHeaderStyled key={budget}>
                    {new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(budget)}
                  </TableCellHeaderStyled>
                ))}
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainerStyled>
      </RootStyled>
    </Paper>
  );
}
